if ( typeof AnnouncementBar !== 'function' ) {

  class AnnouncementBar extends HTMLElement {

    constructor() {
      super();

      this._prefix = window.KT_PREFIX || '';

      this.slider = this.querySelector('[data-js-slider]');
      this.content = this.querySelectorAll(`.${this._prefix}announcement`);
      this.nextButton = this.querySelector(`.${this._prefix}announcement-bar__content-nav--right`);
      this.prevButton = this.querySelector(`.${this._prefix}announcement-bar__content-nav--left`);

      this.index = 0;
      this.length = this.content.length;

      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.autoplayIntervalDelay = this.dataset.autoplayInterval
        ? parseInt(this.dataset.autoplayInterval, 10)
        : 5000;

      this._autoplayInterval = null;

      this.toggleButton = this.querySelector('[data-js-autoplay-toggle]');

      if ( this.nextButton ) {
        this.nextButton.addEventListener('click', () => {
          this.changeSlide('next');
        });
      }

      if ( this.prevButton ) {
        this.prevButton.addEventListener('click', () => {
          this.changeSlide('prev');
        });
      }

      if ( this.toggleButton ) {
        this.toggleButton.addEventListener('click', () => {
          this.togglePause();
        });
      }

      if ( this.autoplayEnabled && this.length > 1 ) {
        this.startAutoplay();
      }
    }

    togglePause() {
      if ( this._autoplayInterval ) {
        this.stopAutoplay();
        this._reflectPausedUI();
      } else {
        this.startAutoplay();
        this._reflectRunningUI();
      }
    }

    _reflectPausedUI() {
      if ( !this.toggleButton ) return;
      this.toggleButton.setAttribute('aria-pressed', 'true');
      this.toggleButton.setAttribute('aria-label', window.KROWN.settings.locales.resume_announcement_autoplay);
      this.toggleButton.classList.add('is-paused');
      const label = this.toggleButton.querySelector('[data-js-autoplay-label]');
      if ( label ) label.textContent = window.KROWN.settings.locales.resume_autoplay;
    }

    _reflectRunningUI() {
      if ( !this.toggleButton ) return;
      this.toggleButton.setAttribute('aria-pressed', 'false');
      this.toggleButton.setAttribute('aria-label', window.KROWN.settings.locales.pause_announcement_autoplay);
      this.toggleButton.classList.remove('is-paused');
      const label = this.toggleButton.querySelector('[data-js-autoplay-label]');
      if ( label ) label.textContent = window.KROWN.settings.locales.pause_autoplay;
    }

    startAutoplay() {
      this.stopAutoplay();

      const tick = () => {
        if ( this.index < this.length - 1 ) {
          this.changeSlide('next');
        } else {
          this.index = -1;
          this.changeSlide('next');
        }
      };

      this._autoplayInterval = setInterval(tick, this.autoplayIntervalDelay);
    }

    stopAutoplay() {
      if ( this._autoplayInterval ) {
        clearInterval(this._autoplayInterval);
        this._autoplayInterval = null;
      }
    }

    changeSlide(direction) {
      if (!this.slider || !this.length) return;

      this.nextButton?.classList.remove(`${this._prefix}announcement-bar__content-nav--disabled`);
      this.prevButton?.classList.remove(`${this._prefix}announcement-bar__content-nav--disabled`);

      if ( direction === 'next' ) {
        this.index++;
      } else if ( direction === 'prev' ) {
        this.index--;
      }

      if ( this.autoplayEnabled ) {
        if ( this.index < 0 ) this.index = this.length - 1;
        if ( this.index > this.length - 1 ) this.index = 0;
      } else {
        if ( this.index < 0 ) this.index = 0;
        if ( this.index > this.length - 1 ) this.index = this.length - 1;

        if ( this.index === this.length - 1 ) {
          this.nextButton?.classList.add(`${this._prefix}announcement-bar__content-nav--disabled`);
        }
        if ( this.index === 0 ) {
          this.prevButton?.classList.add(`${this._prefix}announcement-bar__content-nav--disabled`);
        }
      }

      this.slider.scrollTo({
        top: 0,
        left: this.content[this.index].offsetLeft,
        behavior: 'smooth'
      });
    }

  }

  if ( typeof customElements.get('announcement-bar') === 'undefined' ) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

}